import { CustomCellEditorProps } from "@ag-grid-community/react";
import { HStack, Tooltip } from "@chakra-ui/react";
import { formatISO, isValid, parseISO } from "date-fns";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";
import { SimpleDateInput } from "shared/components/input/date/SimpleDateInput";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { ErrorIcon } from "shared/icons/ErrorIcon";

export const MaybernTableDateCellEditor: React.FC<CustomCellEditorProps> = (
  params,
) => {
  const { column, node, value, context, onValueChange } = params;

  const isEditable = column.isCellEditable(node);
  const error = getMaybernTableCellError({ column, node, context });
  const { t } = useTranslation(["common"]);
  const ref = useRef<HTMLInputElement>(null);
  const isFormDisabled = useIsFormDisabled();
  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <HStack width="100%">
      <SimpleDateInput
        ref={ref}
        variant="simple-table"
        title={t("common:enterDate")}
        value={value ? parseISO(value) : undefined}
        onChangeValue={(val) =>
          onValueChange(
            val && isValid(val)
              ? formatISO(val, { representation: "date" })
              : undefined,
          )
        }
        isDisabled={isFormDisabled || !isEditable}
      />

      {error && (
        <Tooltip openDelay={0} bg="red.600" color="white" label={error}>
          <ErrorIcon ml="-8px" mr="8px" />
        </Tooltip>
      )}
    </HStack>
  );
};
